// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__u8BSW","root":"style_root__IvEry","inner":"style_inner__b0hs6"};